import React, { Component } from 'react';

import Loader from 'react-loader-advanced';
import ReactLoading from 'react-loading';

/* React Router */
import { withRouter } from 'react-router-dom'

/* Result */
import Result from 'iotera-base/result'

/* Redux */
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux';

/* Sagas Action */
import { buildWBoundActions, buildWSelector } from '../../redux/ducks'
import { actions as notificationActions } from '../../redux/ducks/notification'

/* Routes */
import { domainIsTenant as dit, S, domain } from '../../routes/routes'

/* Object Json */
import { safeGetWithType, parse, stringify, safeGet, clean, stringifyFormatted } from 'iotera-base/json';
import { isEmpty, isNone } from 'iotera-base/object';

import { IoteraForm } from '../../lib/components/form';
import { SubViewHeader } from '../../lib/components/subHeader';
import { Button } from '@material-ui/core';
import { AreaInput, TextInput } from '../../lib/components/textInput';
import { setCallbackGlobal, unsetCallbackGlobal } from '../../lib/components/callbackGlobal';

const EDIT = "EDIT";
const WKEY = "RULE_EDIT";
const wSelector = buildWSelector(WKEY);
const wBoundActions = buildWBoundActions(WKEY);

function schema() {
  return {
    "definitions": {
      "Category": {
        "title": "Category",
        "type": "number",
        "anyOf": [
          {
            type: 'number',
            enum: [
              11
            ],
            title: 'Incoming Device Data'
          },
          {
            type: 'number',
            enum: [
              12
            ],
            title: 'Incoming Device Multiple Data'
          },
          {
            type: 'number',
            enum: [
              21
            ],
            title: 'Device Status V0'
          },
          {
            type: 'number',
            enum: [
              22
            ],
            title: 'Device Status *NEW*'
          },
          {
            type: 'number',
            enum: [
              31
            ],
            title: 'Incoming Device State'
          },
          {
            type: 'number',
            enum: [
              32
            ],
            title: 'State Deleted'
          },
          {
            type: 'number',
            enum: [
              111
            ],
            title: 'Device Created'
          },
          {
            type: 'number',
            enum: [
              112
            ],
            title: 'Device Info Updated'
          },
          {
            type: 'number',
            enum: [
              113
            ],
            title: 'Device Sensors Updated'
          },
          {
            type: 'number',
            enum: [
              119
            ],
            title: 'Device Deleted'
          },
          {
            type: 'number',
            enum: [
              501
            ],
            title: 'Subscription Notification'
          },
          {
            type: 'number',
            enum: [
              931
            ],
            title: 'Device State Records Auto Activation'
          },
          {
            type: 'number',
            enum: [
              10009
            ],
            title: 'Iotera Tap Node Expired'
          }
        ]
      }
    },
    type: "object",
    required: ["name", "category", "condition", "action", "details"],
    properties: {
      name: { type: "string", title: "Nama", maxLength: 30 },
      key: { type: "string", title: "Key", maxLength: 30 },
      description: { type: "string", title: "Deskripsi", maxLength: 128, default: '' },
      category: {
        "$ref": "#/definitions/Category",
        "title": "Category"
      },
      condition: { type: "string", title: "Kondisi" },
      action: { type: "string", title: "Aksi" },
      details: { type: "string", title: "Details" },
    }
  }
};

const uiSchema = {
  name: {
    "ui:widget": (props) => {
      return (
        <TextInput
          id="name"
          type="text"
          label="Nama"
          placeholder="Nama"
          textTooltip="Masukkan nama untuk rule ini"
          className="custom"
          value={props.value}
          required={props.required}
          onChange={event => props.onChange(event.target.value)} />
      )
    },
    "ui:options": {
      label: false
    }
  },
  key: {
    "ui:disabled": true
  },
  description: {
    "ui:widget": (props) => {
      return (
        <TextInput
          id="description"
          type="text"
          label="Deskripsi"
          placeholder="Deskripsi"
          textTooltip="Masukkan deskripsi untuk rule ini"
          className="custom"
          value={props.value}
          required={props.required}
          onChange={event => props.onChange(event.target.value)} />
      )
    },
    "ui:options": {
      label: false
    }
  },
  category: {
    "ui:disabled": true
  },
  condition: {
    "ui:widget": (props) => {
      return (
        <AreaInput
          id="condition"
          type="text"
          label="Kondisi"
          textTooltip="Kondisi yang akan men-trigger rule ini untuk melakukan aksi"
          value={props.value}
          required={props.required}
          onChange={event => props.onChange(event.target.value)}
          areaHeight={200}
          {...props}
        />
      )
    },
    "ui:options": {
      label: false
    }
  },
  action: {
    "ui:widget": (props) => {
      return (
        <AreaInput
          id="action"
          type="text"
          label="Aksi"
          textTooltip="Aksi yang terjadi bila kondisi rule terpenuhi/sesuai"
          value={props.value}
          required={props.required}
          onChange={event => props.onChange(event.target.value)}
          areaHeight={200}
          {...props}
        />
      )
    },
    "ui:options": {
      label: false
    }
  },
  details: {
    "ui:widget": (props) => {
      return (
        <AreaInput
          id="details"
          type="text"
          label="Details"
          textTooltip="Details"
          value={props.value}
          required={props.required}
          onChange={event => props.onChange(event.target.value)}
          areaHeight={100}
          {...props}
        />
      )
    },
    "ui:options": {
      label: false
    }
  }
};

class RuleEdit extends Component {
  constructor(props) {
    super(props);
    const ruleId = safeGet(this, ['props', 'match', 'params', 'id']);
    this.state = {
      ruleId,
      loading: false,
      formData: {}
    }
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    const { ruleId } = _state;
    if (isNone(ruleId)) {
      return;
    }
    const domainIsTenant = dit(_props);
    const domains = domain(_props);
    // callback global
    setCallbackGlobal(_props)
    _props.wInitRequestCall(
      {
        wparam: { ...domainIsTenant, path: '/service/web/rule/get/id/' + ruleId },
        wcallback: {
          started: function (id) {
          }
        },
        wreducer: {
          rparse: function (id, rparse, rpayload) {
            let item = {};
            let rule = rpayload;
            item.id = safeGetWithType(rule, ['id'], '');
            item.name = safeGetWithType(rule, ['name'], '');
            item.key = safeGetWithType(rule, ['key'], '-');
            item.category = safeGetWithType(rule, ['category'], 11);
            item.description = safeGetWithType(rule, ['description'], '');
            item.condition = stringify(safeGetWithType(rule, ['condition'], {}));
            item.action = stringify(safeGetWithType(rule, ['action'], {}));
            item.details = stringify(safeGetWithType(rule, ['details'], {}));
            clean(item)
            _this.setState({ loading: false })
            return item;
          }
        }
      }
    );
    _props.wSetConfig({
      single_config: {
        [EDIT]: {
          wparam: {
            ...domainIsTenant,
            method: "POST",
            path: "/service/web/rule/edit"
          },
          wcallback: {
            finished: function (id, result) {
              if (result.code === Result.HTTP.OK) {
                const responseResult = safeGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
                if (responseResult === Result.SUCCESS) {
                  _this.setState({ loading: false })
                  // Magic to refresh routes
                  _props.history.push('..')
                  _props.history.push('..' + S + domains + S + '_rule_list_')
                  _props.showSingleNotification({ message: 'Edit rule sukses', level: 'success' });
                  return;
                }
              }
              _this.setState({ loading: false })
              _props.showSingleNotification({ message: 'Edit rule gagal', position: 'tr', level: 'error' });
            }
          }
        }
      }
    });
  }

  componentWillUnmount() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    const { ruleId } = _state;
    if (isNone(ruleId)) {
      return;
    }
    // callback global
    unsetCallbackGlobal(_props)
    _props.wUnsetConfig({ key: WKEY });
  }

  goTo(link) {
    this.props.history.push(link)
  }

  handleChange(event) {
    this.setState({ formData: event.formData })
  }

  handleSubmit(event) {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    const { ruleId } = _state;
    if (isEmpty(ruleId)) {
      return;
    }
    let submitData = safeGet(_state, ['formData'])
    const name = safeGetWithType(submitData, ['name'], '');
    const description = safeGetWithType(submitData, ['description'], '');
    const category = safeGetWithType(submitData, ['category'], 11);
    let condition = safeGetWithType(submitData, ['condition'], '');
    let action = safeGetWithType(submitData, ['action'], '');
    let details = safeGetWithType(submitData, ['details'], '');
    let condition_object = parse(condition)
    let action_object = parse(action)
    let details_object = parse(details)
    if (isNone(condition_object)) {
      _props.showSingleNotification({ message: 'Kondisi harus dalam bentuk JSON yang benar', level: 'warning' });
      _this.setState({ formData: submitData })
      return;
    }
    if (isNone(action_object)) {
      _props.showSingleNotification({ message: 'Aksi harus dalam bentuk JSON yang benar', level: 'warning' });
      _this.setState({ formData: submitData })
      return;
    }
    if (isNone(details_object)) {
      _props.showSingleNotification({ message: 'Details harus dalam bentuk JSON yang benar', level: 'warning' });
      _this.setState({ formData: submitData })
      return;
    }
    submitData['condition'] = stringifyFormatted(condition_object)
    submitData['action'] = stringifyFormatted(action_object)
    submitData['details'] = stringifyFormatted(details_object)
    _this.setState({ formData: submitData })
    let ruleBody = {
      name,
      category,
      condition: condition_object,
      action: action_object,
      details: details_object,
      description,
      id: ruleId
    }
    clean(ruleBody);
    _this.setState({ loading: true });
    _props.wSingleRequestCall({
      id: EDIT,
      body: ruleBody
    });
  }

  render() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    const { formData } = _state
    let dataToShow = {}
    let items = safeGet(_props, ['items'], {});
    if (!isEmpty(formData)) {
      dataToShow = formData
    }
    else {
      if (!isEmpty(items)) {
        dataToShow = items
        _this.setState({ formData: dataToShow })
      }
    }
    const { loading } = _state;
    const spinner =
      <div className='centeringItem'>
        <ReactLoading type='bubbles' color='#000' />
      </div>
    if (!isEmpty(dataToShow)) {
      return (
        <Loader show={loading} message={spinner} backgroundStyle={{ backgroundColor: '#ffffff', opacity: 0.3 }}>
          <div className="view">
            <SubViewHeader title='Edit Rule' subTitle='Formulir edit rule' />
            <div className="io-container mt-12">
              <IoteraForm
                formData={dataToShow}
                schema={schema()}
                uiSchema={uiSchema}
                onSubmit={_this.handleSubmit}
                onChange={_this.handleChange}
              >
                <div className="button-right">
                  <Button variant="outlined" type="button" size="large"
                    style={{ minWidth: '0%' }} onClick={(e) => _this.goTo('..' + S + '_rule_list_')} >Batal</Button>
                  <Button variant="contained" size="large" color="primary" type="submit"
                    style={{ marginLeft: 10, minWidth: '0%' }}>Simpan</Button>
                </div>
              </IoteraForm>
            </div>
          </div>
        </Loader>
      );
    }
    else {
      return (
        <div className="view">
          <SubViewHeader title='Edit Rule' subTitle='Formulir edit rule' />
          <div className="io-container mt-12">
          </div>
        </div>
      );
    }
  }
}

const mapStateToProps = function (state) {
  return {
    items: wSelector.getSoleInitMappedRPayload(state),
    ruleId: wSelector.getSoleInitMappedRPayload(state, 'id')
  }
}

const mapDispatchToProps = function (dispatch) {
  return {
    ...wBoundActions(dispatch),
    ...bindActionCreators(notificationActions, dispatch)
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(RuleEdit));